import React from 'react';
import Kicker from '../ui/Kicker';
import Button from '../ui/Button';
import ScrollHint from '../ui/ScrollHint';

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container">
        <div className="hero-content reveal">
          <Kicker>AI &amp; emerging tech studio</Kicker>
          <h1>
            {/* The space sits outside the span: an inline-block trims its own
                leading whitespace, which would close up the gap before the dash. */}
            Put AI to work{' '}
            <span className="accent">&mdash; not in a pilot.</span>
          </h1>
          <p>
            Briva moves AI and emerging tech out of the slide deck and into production —
            strategy, working prototypes and systems your team runs on Monday morning.
          </p>
          <div className="hero-actions">
            <Button
              variant="primary"
              size="large"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Start a conversation
            </Button>
            <Button
              size="large"
              onClick={() => document.getElementById('capabilities')?.scrollIntoView({ behavior: 'smooth' })}
            >
              See what we build
            </Button>
          </div>
        </div>
      </div>
      <ScrollHint targetId="narrative" />
    </section>
  );
}
